import { safeStr } from './helper';
import { getInternationalDocRules, onlyDigits } from './masks';

export function validatePersonalDataDetailed(form) {
  const errors = {};

  const firstName = safeStr(form.firstName).trim();
  const lastName = safeStr(form.lastName).trim();
  const email = safeStr(form.email).trim();
  const docType = safeStr(form.docType).trim();
  const docValue = safeStr(form.docValue).trim();
  const ddiDigits = onlyDigits(form.ddi);
  const phoneDigits = onlyDigits(form.phone);

  if (!firstName) errors.firstName = 'Esse campo é obrigatório.';
  if (!lastName) errors.lastName = 'Esse campo é obrigatório.';

  if (!email) errors.email = 'Esse campo é obrigatório.';
  else if (!/^\S+@\S+\.\S+$/.test(email)) errors.email = 'Esse valor é inválido.';

  if (!ddiDigits) errors.ddi = 'Esse campo é obrigatório.';
  else if (ddiDigits.length < 1 || ddiDigits.length > 3) errors.ddi = 'Esse valor é inválido.';

  if (!phoneDigits) errors.phone = 'Esse campo é obrigatório.';
  else if (phoneDigits.length < 10 || phoneDigits.length > 11) errors.phone = 'Esse valor é inválido.';
  else if (validateSouthAmericaPhoneFormat(form.ddi + ' ' + form.phone).status) errors.phone = validateSouthAmericaPhoneFormat(form.ddi + ' ' + form.phone).message;

  if (!docType) errors.docType = 'Esse campo é obrigatório.';

  if (!docValue) {
    errors.docValue = 'Esse campo é obrigatório.';
  } else if (docType === 'cpfCnpj') {
    const docChars = docValue.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (!(docChars.length === 11 || docChars.length === 14)) errors.docValue = 'Esse valor é inválido.';
  } else {
    const docDigits = onlyDigits(docValue);
    const ruleSet = getInternationalDocRules(ddiDigits);

    if (ruleSet?.rules?.length) {
      const allowedLengths = ruleSet.rules.map((rule) => rule.length);
      if (!allowedLengths.includes(docDigits.length)) errors.docValue = 'Esse valor é inválido.';
    } else if (docDigits.length < 4) {
      errors.docValue = 'Esse valor é inválido.';
    }
  }

  return errors;
}

export function validateSouthAmericaPhoneFormat(value) {
  if (!value) {
    return {
      status: false,
      message: 'Telefone não informado'
    }
  }

  const southAmericaDDI = [
    '51',  // Peru
    '54',  // Argentina
    '55',  // Brasil
    '56',  // Chile
    '57',  // Colômbia
    '58',  // Venezuela
    '591', // Bolívia
    '592', // Guiana
    '593', // Equador
    '595', // Paraguai
    '597', // Suriname
    '598', // Uruguai
  ]

  const ddiRegex = southAmericaDDI.join('|')

  const phoneRegex = new RegExp(
    `^(${ddiRegex}) \\(\\d{1,3}\\) \\d{4,5}-\\d{4}$`
  )

  if (!phoneRegex.test(value)) {

    return {
      status: true,
      message: 'Telefone inválido. Use o formato válido para países da América do Sul.'
    }
  }

  return {
    status: false,
    message: 'Telefone válido.'
  }
}
